<script>

export default {
	components: {},
	props: ['id', 'firstRows', 'columns'],
	data() {
		return {
			availableFields: [
				'email',
				'phone',
				'name',
				'first_name',
				'last_name',
				'address',
				'postal_code',
				'city',
				'note',
				'email_marketing_agreement',
				'sms_marketing_agreement'
			],
			selectedFields: [],
			errors: {},
			submitDisabled: true,
			isLoading: false
		}
	},
	beforeMount() {

		for (let j = 0; j < this.columns; j++) {
			this.selectedFields[j] = 'no_import';
		}

		for (let j = 0; j < this.firstRows[0].length; j++) {

			let fieldKey = this.firstRows[0][j];

			if (fieldKey === 'Etunimi' || fieldKey === 'first_name') {
				this.fieldSelected(j, 'first_name');
			} else if (fieldKey === 'Sukunimi' || fieldKey === 'last_name') {
				this.fieldSelected(j, 'last_name');
			} else if (fieldKey === 'Nimi' || fieldKey === 'name') {
				this.fieldSelected(j, 'name');
			} else if (fieldKey === 'Email' || fieldKey === 'email') {
				this.fieldSelected(j, 'email');
			} else if (fieldKey === 'Puhelin' || fieldKey === 'phone') {
				this.fieldSelected(j, 'phone');
			} else if (fieldKey === 'Osoite' || fieldKey === 'address') {
				this.fieldSelected(j, 'address');
			} else if (fieldKey === 'Postinumero' || fieldKey === 'postal_code') {
				this.fieldSelected(j, 'postal_code');
			} else if (fieldKey === 'Kaupunki' || fieldKey === 'city') {
				this.fieldSelected(j, 'city');
			} else if (fieldKey === 'Yleistiedot' || fieldKey === 'note') {
				this.fieldSelected(j, 'note');
			} else if (fieldKey === 'Email-markkinointilupa' || fieldKey === 'email_marketing_agreement') {
				this.fieldSelected(j, 'email_marketing_agreement');
			} else if (fieldKey === 'Tekstiviestimarkkinointilupa' || fieldKey === 'sms_marketing_agreement') {
				this.fieldSelected(j, 'sms_marketing_agreement');
			}

		}

	},
	methods: {
		reset()
		{
			$('#confirmationRestartModal').modal('toggle');
		},
		async onConfirm() {

			this.isLoading = true;

			await axios.post('/import-customers/' + this.id + '/map-fields', {fields: this.selectedFields}).then(response => {

				window.location = '/import/' + this.id +  '/handle-invalid-rows';

			}).catch(error => {

				if (error && error.response.status === 422 && error.response.data.errors) {
					this.errors = error.response.data.errors || {};
				}

				this.isLoading = false;

			});

		},
		fieldSelected(index, value) {

			for (let i = 0; i < this.selectedFields.length; i++) {

				if (index !== i && this.selectedFields[i] === value && value !== 'no-import') {
					this.selectedFields[i] = null;
				}

			}

			this.selectedFields[index] = value;

			this.submitDisabled = false;

			if (this.selectedFields.includes('email') === false) {
				this.submitDisabled = true;
				return;
			}

			if (this.selectedFields.includes('phone') === false) {
				this.submitDisabled = true;
				return;
			}

			if (this.selectedFields.includes('name') === true || (this.selectedFields.includes('first_name') === true && this.selectedFields.includes('last_name') === true)) {
				this.submitDisabled = false;
				return;
			}

			this.submitDisabled = true;

		}
	}
}

</script>